/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./ModalSurveys.style";

// Hooks
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent";

import useDoctorData from "../../../../../hooks/useDoctorData";
import ModalSendSurvey from "../modalSendSurvey";
import ModalAddSurveyData from "../modalAddSurveyData";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import SurveyPreview from "../modalSendSurvey/components/surveyPreview";

// Assets
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;

function ModalSurveys({ 
  setModalActive,
  surveyForPreview,
  processId,
  patientId,
  surveyId
}) {

  const { t, i18n: { language } } = useTranslation("global");

  const { doctorData } = useDoctorData();
  const [formSuccess, setFormSuccess] = useState(null); 

  const [loadingData, setLoadingData] = useState(false)
  const [tabSelected, setTabSelected] = useState(0)
  const [tabPreSelected, setTabPreSelected] = useState(0)

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setModalActive(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  if(formSuccess)
    return(
      <S.ModalSendSurvey>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              button1Text={t("globally.done")}
              title={t("surveys.sendSurveyModal.surveySent")}
            />
          </div>  
        </div>
      </S.ModalSendSurvey>
    )

  if(formSuccess === false)
    return(
      <S.ModalSendSurvey>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              title={t("globally.errorForm")}
              subtitle={t("surveys.sendSurveyModal.surveySentError")}
              button1Text={t("globally.accept")}            
            />
          </div>
        </div>
      </S.ModalSendSurvey>
    )

  return (
    <>
      <S.ModalSendSurvey
        hidden={!loadingData}
      >
        <div className="modal-background">
        </div>
        <div className="modal-container">
          <div className="modal-reaction">
            <ZaiaReaction
              widthimg={"150px"}
              zaiaImg={logoZaiaLoading}
              padding={"200px 0px"}
            />
          </div>
        </div>
      </S.ModalSendSurvey>
      <S.ModalSendSurvey
        completeScreen={tabSelected !== 0}
        hidden={loadingData}
      >
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          {
            surveyForPreview
            ? <SurveyPreview
              previewSurveyView={surveyForPreview}
            />
            : (
              tabSelected === 0 ||
              (
                tabSelected === 0 &&
                !surveyForPreview
              )
            ) &&
            <div className="survey-options">
              <div className="survey-options__text">
                {t("surveys.healthSurvey")}
              </div>
              <div className="survey-options__subtitle">
                {t("surveys.whatProcessDoYouWantToDo")}
              </div>
              <div className="modal-tabs">
                <div
                  className={`tab ${1 === tabPreSelected && "tab tab--selected"}`}
                  onClick={() => 
                    {
                      setTabPreSelected(1)
                    }
                  }
                >
                  {t("surveys.sendSurvey")}
                </div>
                <div className="tab-separator"></div>
                <div
                  className={`tab ${2 === tabPreSelected && "tab tab--selected"}`}
                  onClick={() => 
                    {
                      setTabPreSelected(2)
                    }
                  }
                >
                  {t("surveys.fillOutSurvey")}
                </div>
              </div>
              <div className="options">
                <div className="options__left">
                  <FlorenzButton
                    typeStyle={"secondaryWhite"}
                    size="s"
                    text={t("globally.cancel")}
                    widthComplete={true}
                    onClick={() => setModalActive(false)}
                  />
                </div>
                <div className="options__right">
                  <FlorenzButton
                    typeStyle={"primary"}
                    size="s"
                    text={t("globally.accept")}
                    widthComplete={true}
                    disabled={tabPreSelected === 0}
                    icon={tabPreSelected === 0 && "zaia-i-lock-chat"}
                    onClick={() => {
                      setTabSelected(tabPreSelected);
                    }}
                  />
                </div>
              </div>
            </div>
          }
          {
            tabSelected === 1 &&
            <div className="modal-content-dinamic">
              <div 
                className="dinamic-component"
              >
                <ModalSendSurvey
                  surveyForPreview={surveyForPreview}
                  processId={processId}
                  patientId={patientId}
                  setFormSuccess={setFormSuccess}
                  setLoadingData={setLoadingData}
                  setModalActive={setModalActive}
                />
              </div>
            </div>
          }
          {
            tabSelected === 2 &&
            <div className="modal-content-dinamic">
              <div 
                className="dinamic-component"
              >
                <ModalAddSurveyData
                  patientID={patientId}
                  processID={processId}
                  surveyId={surveyId}
                  setFormSuccess={setFormSuccess}
                  setLoadingData={setLoadingData}
                  setModalActive={setModalActive}
                />
              </div>
            </div>
          }
        </div>
      </S.ModalSendSurvey>
    </>
  );
}


export default ModalSurveys;
